<template>
    <div>
        <v-container bg fill-height grid-list-md text-xs-center>
            <v-layout row wrap align-center>
                <v-flex>
                    <div class="text-xs-center mt-30">
                        <img :src="appLogo"
                             class="img-responsive mb-3"
                             width="90" />
                        <h2 class="mb-3">Controllo Abbonamenti</h2>
                        <p class="fs-14">Inserisci il tuo nome utente e password per accedere.</p>
                        <v-form v-model="valid" class="mb-4">
                            <v-text-field label="Utente"
                                          v-model="user.userName"
                                          required
                                          v-on:keypress.enter="signin"></v-text-field>
                            <v-text-field label="Password"
                                          v-model="user.password"
                                          type="password"
                                          :rules="passwordRules"
                                          required
                                          v-on:keypress.enter="signin"></v-text-field>
                            <div class="title" ref="errorMessage" v-if="error"><span class="red--text">Nome utente o password non validi</span></div>
                            <div>
                                <v-btn large @click="signin" block color="primary">ACCEDI</v-btn>
                            </div>
                        </v-form>

                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
    import Slick from "vue-slick";
    import { mapGetters } from "vuex";
    //import SessionSliderWidget from "Components/Widgets/SessionSlider";
    import AppConfig from "Constants/AppConfig";

    import api from "Api";



    export default {
        components: {
            Slick
        },
        data() {
            return {
                error: false,
                checkbox: false,
                valid: false,
                user: {
                    userName: "",
                    password: ""
                },
                emailRules: [
                    v => !!v || "E-mail is required",
                    v =>
                        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                        "E-mail must be valid"
                ],
                passwordRules: [v => !!v || "Password is required"],
                appLogo: AppConfig.appLogo2,
                brand: AppConfig.brand
            };
        },
        methods: {
            signin() {
                var instance = this;
                instance.error = false;

                api.newInstance()
                    .post("authenticate", instance.user)
                    .then(response => {
                        localStorage.setItem('token', response.data.token);
                        this.$router.push('/abbonati/ricerca')
                    })
                    .catch(error => {
                        instance.error = true;
                    });
            }
        },
        computed: {
            slickOptions() {
                return {
                    dots: true,
                    infinite: true,
                    speed: 500,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    arrows: false,
                    rtl: this.$store.getters.rtlLayout
                };
            }
        },

    };
</script>
